/* eslint-disable no-return-assign */
import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Step3Module1Operations } from '../../../../ducks/step3';
import { SectionContainer, BottomSectionBody, SelectContainer, InputContainer, Title, ErrorMessage } from './styles';

const AdditionalSection = props => {
  const { features, register, errors } = props;
  const { featureSelect, featureInputs } = features;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const showTitle = (featureSelect && featureSelect.length > 0) || (featureInputs && featureInputs.length > 0);

  return (
    <SectionContainer data-repa='step3-additional'>
      {showTitle && <Title data-repa='step3-additional-title'>{t('publisher.step3.module1.features.title')}</Title>}
      <BottomSectionBody data-repa='step3-additional-bottomSectionBody'>
        {featureSelect &&
          featureSelect.map(fs => (
            <SelectContainer key={`select-${fs.id}`} hasValue={fs.value}>
              <label data-repa={`step3-additional-selectFeature-label-${fs.id}`} htmlFor={`select-${fs.id}`}>
                {fs.name}
              </label>
              <select
                data-repa={`step3-additional-selectFeature-${fs.id}`}
                value={fs.value || ''}
                id={`select-${fs.id}`}
                onChange={e => dispatch(Step3Module1Operations.changeInput('featureSelect', fs.id, e.target.value))}
              >
                <option
                  data-repa={`step3-additional-selectFeature-label-${fs.id}-option-placeholder`}
                  key='select-option'
                  value=''
                >
                  {t('publisher.step3.module1.features.placeholder')}
                </option>
                {fs.options.map(option => (
                  <option
                    data-repa={`step3-additional-selectFeature-${fs.id}-option-${option.value}`}
                    key={`select-option-${option.value}`}
                    value={option.value}
                  >
                    {option.description}
                  </option>
                ))}
              </select>
            </SelectContainer>
          ))}
        {featureInputs &&
          featureInputs.map(fi => (
            <InputContainer data-repa={`step3-additional-inputFeature-inputConteiner-${fi.id}`} key={`input-${fi.id}`}>
              <label data-repa={`step3-additional-inputFeature-label-${fi.id}`} htmlFor={`input-${fi.id}`}>
                {fi.name}
              </label>
              <input
                data-repa={`step3-additional-inputFeature-${fi.id}`}
                id={`input-${fi.id}`}
                onPaste={e => e.preventDefault()}
                onKeyPress={evt => {
                  if (evt.key === 'Enter') evt.preventDefault();
                }}
                onInput={evt => (evt.target.value = evt.target.value.replace(/[^0-9]*/g, ''))}
                type='text'
                name={fi.id}
                ref={register}
                placeholder='0'
                maxLength={7}
              />
              {errors[fi.id] && (
                <ErrorMessage data-repa={`step3-additional-inputFeature-error-${fi.id}-validation`}>
                  {`${t(`publisher.step3.module1.validation.${errors[fi.id].type}`)}${
                    fi[`${errors[fi.id].type}Validation`]
                  }.`}
                </ErrorMessage>
              )}
            </InputContainer>
          ))}
      </BottomSectionBody>
    </SectionContainer>
  );
};

export { AdditionalSection };
